// extracted by mini-css-extract-plugin
export default {"root":"_1eWOo","first-row":"_1BmL0","firstRow":"_1BmL0","second-row":"_3v2yi","secondRow":"_3v2yi"};